import type { ReactNode } from "react";
import { InputAdornment, TextField } from "@mui/material";

// White like the editable fields, with a neutral border and label that never turn blue,
// not even on click: only an editable field carries the primary border.
export const ReadOnlyField = ({
	label,
	value,
	numeric = false,
	action,
}: {
	label: string;
	value: string | null | undefined;
	numeric?: boolean;
	/** A button at the end of the box, for an action on this value (e.g. change a roll). */
	action?: ReactNode;
}) => (
	<TextField
		label={label}
		value={value || "-"}
		fullWidth
		size="small"
		slotProps={{
			inputLabel: { shrink: true },
			input: {
				readOnly: true,
				endAdornment: action ? (
					<InputAdornment position="end">{action}</InputAdornment>
				) : undefined,
			},
			htmlInput: {
				tabIndex: -1,
				style: numeric
					? { textAlign: "right", fontVariantNumeric: "tabular-nums" }
					: undefined,
			},
		}}
		sx={{
			"& .MuiOutlinedInput-root": {
				"& fieldset": { borderColor: "divider", borderWidth: 1 },
				"&:hover fieldset": { borderColor: "divider", borderWidth: 1 },
				"&.Mui-focused fieldset": { borderColor: "divider", borderWidth: 1 },
			},
			"& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused": {
				color: "text.secondary",
			},
			"& .MuiInputBase-input": { cursor: "default" },
		}}
	/>
);
